/**
 * Papier Royal — pastilles couleur des cards marchandes : le clic change la photo
 * de la card, sur place, sans quitter la page.
 *
 * Le lien reste un vrai <a href="…?variant=…"> : clic milieu, ⌘/Ctrl+clic et
 * « ouvrir dans un nouvel onglet » continuent de mener à la fiche avec la bonne
 * teinte, et la pastille reste utile si le JS ne se charge pas. On n'intercepte
 * que le clic gauche simple.
 *
 * Écouteur DÉLÉGUÉ sur document : les grilles de collection re-rendent leurs cards
 * (filtres, pagination, changement de vue) et un écouteur posé par card serait perdu
 * à chaque rendu. Le garde `__prMcardSwatch` évite les doublons, le snippet étant
 * inclus une fois par card.
 */
(function () {
  'use strict';
  if (window.__prMcardSwatch) return;
  window.__prMcardSwatch = true;

  function apply(sw) {
    var card = sw.closest('.pr-mcard-item');
    if (!card) return false;
    var img = card.querySelector('.pr-mcard__media-primary');
    var src = sw.getAttribute('data-img');
    if (!img || !src) return false;

    // `srcset` prime sur `src` : sans le retirer, le navigateur continuerait de
    // servir l'ancienne teinte depuis le jeu de résolutions d'origine.
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.src = src;

    // L'image de survol (2e photo, fondu au hover) montre une AUTRE teinte que celle
    // qu'on vient de choisir : on la retire pour ne pas contredire la sélection.
    var hover = card.querySelector('.pr-mcard__media-hover');
    if (hover && hover.parentNode) hover.parentNode.removeChild(hover);
    card.querySelectorAll('.pr-mcard__media--hover').forEach(function (el) {
      el.classList.remove('pr-mcard__media--hover');
    });

    // La teinte choisie devient la destination de l'image ET du bouton, pour que le
    // parcours reste cohérent avec ce qui est affiché.
    var href = sw.getAttribute('href');
    if (href) {
      var media = card.querySelector('a.pr-mcard__media');
      if (media) media.setAttribute('href', href);
      var cta = card.querySelector('a.pr-mcard__cta');
      if (cta) cta.setAttribute('href', href);
      var link = card.querySelector('a.product-card__link');
      if (link) link.setAttribute('href', href);
    }

    card.querySelectorAll('a.pr-mcard__swatch').forEach(function (s) {
      if (s === sw) s.setAttribute('aria-current', 'true');
      else s.removeAttribute('aria-current');
    });
    return true;
  }

  document.addEventListener(
    'click',
    function (e) {
      if (e.defaultPrevented) return;
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var sw = e.target && e.target.closest ? e.target.closest('a.pr-mcard__swatch[data-img]') : null;
      if (!sw) return;
      // On ne préempte le clic QUE si le changement a réellement eu lieu ; sinon on
      // laisse le lien faire son travail et mener à la fiche produit.
      if (apply(sw)) {
        e.preventDefault();
        e.stopPropagation();
      }
    },
    false
  );
})();
